module.exports = __webpack_public_path__ + "static/media/banner-left.aa6f9988.png";